import React from "react";

interface LoadingButtonProps {
    loading: boolean;
    text: string;
    loadingText?: string;
    disabled?: boolean;
    className?: string;
    type?: "button" | "submit";
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
    loading,
    text,
    loadingText = "Procesando...",
    disabled,
    className = "",
    type = "submit",
}) => {
    return (
        <button
            type={type}
            disabled={loading || disabled}
            className={`flex w-full items-center justify-center gap-2 rounded-lg bg-primary py-3 font-medium text-white transition hover:bg-primary/90 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
        >
            {loading && (
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
            )}
            {loading ? loadingText : text}
        </button>
    );
};

export default LoadingButton;
